module.exports = "<gw-pl-yes-no model=\"fakeVM\"></gw-pl-yes-no>"